// removed by extract-text-webpack-plugin
module.exports = {"list":"list--1A_hS"};


//////////////////
// WEBPACK FOOTER
// ./client/components/pdf-links/pdf-links.scss
// module id = 499
// module chunks = 0